<template>
  <div class="fillcontain">
    <search-item @showDialog="showAddDialog"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
      >
        <el-table-column
          v-if="idFlag"
          prop="id"
          label="id"
          align="left"
        ></el-table-column>
        <!-- <el-table-column prop="type" label="自定义条目" align="left"></el-table-column> -->
        <el-table-column
          prop="classTypeId"
          label="班级类型"
          align="left"
          :filters="this.classTypeData"
          :filter-method="filterClassType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterClassType(scope.row)"
              disable-transitions
              >{{ scope.row.classTypeId }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDelete(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <AddStudentAndClassTypeDialog
        v-if="addDialog.show"
        :isShow="addDialog.show"
        :dialogRow="addDialog.dialogRow"
        :stdId="addDialog.username"
        :classTypeList="addDialog.classTypeList"
        @getClassHourList="getStudentAndClassTypeList"
        @closeDialog="hideAddDialog"
      ></AddStudentAndClassTypeDialog>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import * as mutils from "@/utils/mUtils";
import SearchItem from "./components/searchItem";
import AddStudentAndClassTypeDialog from "./components/addStudentAndClassTypeDialog";
import { myTime, formatDateTime } from "../../utils/date.js";
import Pagination from "@/components/pagination";
import { getFormatClassTypes } from "@/api/courseType";
import {
  getStudentAndClassTypeListByStuId,
  deleteStudentAndClassType,
} from "@/api/studentclasstype";
import { getToken } from "@/utils/auth";
import { addOperationRecord } from "@/api/operationrecord";

export default {
  data() {
    return {
      tableData: [],
      classTypeData: [],
      format_class_type_list: {},
      tableHeight: 0,
      loading: false,
      ROLE: 0,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      sortnum: 0,
      addDialog: {
        show: false,
        dialogRow: {},
        classTypeList: {},
        stdId: "",
      },
      studentData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
    };
  },
  components: {
    SearchItem,
    AddStudentAndClassTypeDialog,
    Pagination,
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
  },
  created() {
    this.ROLE = getToken("ROLE");
  },
  mounted() {
    this.getFormatClassTypes();
    this.getStudentAndClassTypeList();
  },
  computed: {
    ...mapGetters(["studentAndClassTypeSearch"]),
  },
  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    // 编辑操作方法
    onEdit(row) {
      this.addDialog.dialogRow = { ...row };
      this.showAddDialog();
    },
    getFormatClassTypes() {
      getFormatClassTypes().then((res) => {
        console.log(res);
        this.classTypeData = res.data.data.classTypeDataList;
        this.format_class_type_list = res.data.data.formatClassTypeList;
        var classTypeData = {
          classTypeList: this.classTypeData,
        };
        this.addDialog.classTypeList = classTypeData;
      });
    },
    //获取课时账单列表数据
    getStudentAndClassTypeList() {
      //   const para = this.classhourSpendData;
      var stdId = this.studentAndClassTypeSearch.stdId;
      this.addDialog.stdId = stdId;
      getStudentAndClassTypeListByStuId(stdId).then((res) => {
        this.tableData = [];
        console.log(res);
        this.loading = false;
        if (res.data.code == 200) {
          this.tableData = res.data.data.studentAndClassTypeDatas;
        }
      });
    },
    // 显示资金弹框
    showAddDialog(val) {
      this.$store.commit("SET_STUDENTANDCLASSTYPE_DIALOG_TITLE", val);
      this.addDialog.show = true;
    },
    hideAddDialog() {
      this.addDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.classhourSpendData.page = val - 1;
      this.getStudentAndClassTypeList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.classhourSpendData.limit = val;
      this.getStudentAndClassTypeList();
    },
    /**
     * 格式化状态
     */
    formatterClassType(item) {
      const type = parseInt(item.classTypeId);
      return this.format_class_type_list[type];
    },
    filterClassType(value, item) {
      const type = parseInt(item.classTypeId);
      return (
        this.format_class_type_list[value] == this.format_class_type_list[type]
      );
    },
    // 编辑操作方法
    onEditStudent(row) {
      //   this.$router.push({ path: "/memberManage/fundList" });
      this.addDialog.dialogRow = { ...row };
      this.showAddDialog();
    },
    // 删除数据
    onDelete(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { id: row.id };
          console.log(para);
          deleteStudentAndClassType(row.id).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              const para = {
                userName: getToken("USERNAME"),
                content: "删除(" + row.id + ")学员班级类型操作",
              };
              addOperationRecord(para).then((res) => {
                console.log(res);
              });
              this.getStudentAndClassTypeList();
            } else {
              this.$message({
                message: "删除失败",
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>


<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>